import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkAll", "check"];

  declare readonly checkAllTarget: HTMLInputElement;
  declare readonly checkTargets: HTMLInputElement[];

  connect() {
    // 初期状態の設定
    this.updateCheckAllState();
  }

  // 全選択チェックボックスが変更されたとき
  toggleAll() {
    const isChecked = this.checkAllTarget.checked;

    // すべての個別チェックボックスを同じ状態に
    this.checkTargets.forEach((checkbox) => {
      checkbox.checked = isChecked;
    });
  }

  // 個別チェックボックスが変更されたとき
  checkChanged() {
    this.updateCheckAllState();
  }

  // 全選択チェックボックスの状態を更新
  updateCheckAllState() {
    if (this.checkTargets.length === 0) return;

    // 全チェックボックスの数とチェック済みの数を取得
    const total = this.checkTargets.length;
    const checked = this.checkTargets.filter((checkbox) => checkbox.checked).length;

    // 全てにチェックが入っている場合のみ、全選択チェックボックスをオンにする
    this.checkAllTarget.checked = total === checked;

    // indeterminate状態は使用しない（jQueryコードに合わせる）
    this.checkAllTarget.indeterminate = false;
  }
}
